import { Controller } from "stimulus"
import currency from '../helpers/currency'

export default class extends Controller {
  static targets = [
    "customerItemTotal",
    "defaultCustomerPrice",
    "defaultQuantity",
    "defaultVendorPrice",
    "projectedFreight",
    "projectedFreightTotal",
    "vendorItemTotal",
    "unitTotal",
    "wrapper",
  ]

  connect() {
    this.recalculate()
  }

  updateAllCustomerPrices() {
    if(this.hasDefaultCustomerPriceTarget) {
      const value = this.defaultCustomerPriceTarget.value
      if(value) {
        this.wrapperTarget.querySelectorAll('.order-line input.customer-price').forEach(target => target.value = value)
      }
      this.recalculate()
    }
  }

  updateAllVendorPrices() {
    const value = this.defaultVendorPriceTarget.value
    if(value) {
      this.wrapperTarget.querySelectorAll('.order-line input.vendor-price').forEach(target => target.value = value)
    }
    this.recalculate()
  }

  updateAllQuantities() {
    const value = this.defaultQuantityTarget.value
    this.wrapperTarget.querySelectorAll('.order-line:not(.order-line-locked) input.quantity').forEach(target => target.value = value)
    this.wrapperTarget.querySelectorAll('.order-line').forEach(row => this.hideLockError(row))
    this.recalculate()
  }

  clearLockError(event) {
    this.hideLockError(event.currentTarget.closest('.order-line'))
  }

  hideLockError(row) {
    row.querySelector('input.quantity').classList.remove('is-invalid')
    row.querySelector('.lock-error').classList.remove('d-block')
  }

  toggleLock(event) {
    const row = event.currentTarget.closest('.order-line')
    const lockedField = row.querySelector('input.locked-field')
    const quantityInput = row.querySelector('input.quantity')
    const errorTarget = row.querySelector('.lock-error')
    const locking = lockedField.value !== 'true'

    if(locking && parseFloat(quantityInput.value || 0) !== 0) {
      quantityInput.classList.add('is-invalid')
      errorTarget.classList.add('d-block')
      return
    }

    this.hideLockError(row)
    lockedField.value = locking ? 'true' : 'false'
    row.classList.toggle('order-line-locked', locking)
    row.classList.toggle('text-muted', locking)

    const icon = event.currentTarget.querySelector('i')
    icon.classList.toggle('bi-lock-fill', locking)
    icon.classList.toggle('bi-unlock', !locking)
    event.currentTarget.title = locking ? 'Unlock size' : 'Lock size (units must be 0)'

    row.querySelectorAll('input[data-tabindex]').forEach(input => {
      input.readOnly = locking
      input.tabIndex = locking ? -1 : input.dataset.tabindex
    })
  }

  recalculate() {
    let runningCustomerTotalCurrency = currency(0)
    let runningVendorTotalCurrency = currency(0)
    let runningTotalQuantity = 0

    this.wrapperTarget.querySelectorAll('.order-line').forEach(target => {
      const quantity = parseFloat(target.querySelector('input.quantity').value)
      const customerPriceTarget = target.querySelector('input.customer-price')
      const customerPriceCurrency = customerPriceTarget ? currency(customerPriceTarget.value) : currency(0)
      const vendorPriceCurrency = currency(target.querySelector('input.vendor-price').value)

      const customerLineTotalTarget = target.querySelector('.customer-line-total')
      const vendorLineTotalTarget = target.querySelector('.vendor-line-total')

      if(!isNaN(quantity)) {
        runningTotalQuantity += quantity
      }

      if(isNaN(quantity) || isNaN(customerPriceCurrency)) {
        customerLineTotalTarget.innerText = ""
      }
      else {
        const customerLineTotalCurrency = customerPriceCurrency.multiply(quantity)
        if(customerLineTotalTarget) {
          customerLineTotalTarget.innerText = customerLineTotalCurrency.format()
        }
        runningCustomerTotalCurrency = runningCustomerTotalCurrency.add(customerLineTotalCurrency)
      }

      if(isNaN(quantity) || isNaN(vendorPriceCurrency)) {
        vendorLineTotalTarget.innerText = ""
      }
      else {
        const vendorLineTotalCurrency = vendorPriceCurrency.multiply(quantity)
        vendorLineTotalTarget.innerText = vendorLineTotalCurrency.format()
        runningVendorTotalCurrency = runningVendorTotalCurrency.add(vendorLineTotalCurrency)
      }
    })

    if(this.hasCustomerItemTotalTarget) {
      this.customerItemTotalTarget.innerText = runningCustomerTotalCurrency.format()
    }
    this.vendorItemTotalTarget.innerText = runningVendorTotalCurrency.format()
    this.unitTotalTarget.innerText = runningTotalQuantity

    const projectedFreightTotal = currency(this.projectedFreightTarget.value).multiply(runningTotalQuantity)
    this.projectedFreightTotalTarget.innerText = projectedFreightTotal.format()
  }
}

